import { postCall, getCall } from "./api";

 // Org-wide day records, optionally bounded by date.
 //
 // The range is not decoration: without it this returns every attendance record
 // the organisation has ever produced, so a dashboard showing one day or one
 // month pays for the entire history and then throws almost all of it away.
 // Callers pass the window they actually render.
 export const getAllDayAttendance = async ({ startDate, endDate, shift } = {}) => {
    const query = new URLSearchParams();
    if (startDate) query.set("startDate", startDate);
    if (endDate) query.set("endDate", endDate);
    if (shift) query.set("shift", shift);
    const qs = query.toString();
    return await getCall({ path: `/facial-recognition-attendance/days${qs ? `?${qs}` : ""}`, });
  };

  export const getAllDaySelfAttendance = async () => {
    return await getCall({ path: `/facial-recognition-attendance/days/self`, });
  };

  // startDate/endDate are ISO date strings ("YYYY-MM-DD"). Passing them scopes
  // the fetch to a single month instead of pulling an employee's whole history.
  export const getAllDayAttendanceByEmployeeId = async (employeeid, range = {}) => {
    const { startDate, endDate } = range;
    const query = new URLSearchParams();
    if (startDate) query.set("startDate", startDate);
    if (endDate) query.set("endDate", endDate);
    const qs = query.toString();
    return await getCall({ path: `/facial-recognition-attendance/days/${employeeid}${qs ? `?${qs}` : ""}`, });
  };

  // One month of the whole roster: per employee their shift, day records and
  // approved leave, plus org holidays. Resolution into statuses happens client
  // side via buildAttendanceMonth, so the muster and the register share one
  // set of rules. `month` is 0-indexed.
  export const getMuster = async ({ year, month, department, q, limit, skip } = {}) => {
    const qs = new URLSearchParams();
    if (year != null) qs.set("year", year);
    if (month != null) qs.set("month", month);
    if (department) qs.set("department", department);
    // searched server-side: the roster is paged, so filtering in the browser
    // could only ever search the page in hand
    if (q) qs.set("q", q);
    if (limit) qs.set("limit", limit);
    if (skip) qs.set("skip", skip);
    return await getCall({ path: `/facial-recognition-attendance/muster?${qs.toString()}` });
  };

  export const getTodayDateString = async () => {
    return await getCall({ path: `/facial-recognition-attendance/today`, });
  };

  export const getDayRecordByDate = async (dateString) => {
    // Both dashboards call this with the date from getTodayDateString, and that
    // call fails for an organisation with no shift set up yet. Without this
    // guard the failure became `.../by-date/undefined` — the literal string in
    // the path — and the server was asked for a day that cannot exist.
    // Interpolating a value into a URL without checking it is how "undefined"
    // ends up in an access log.
    if (!dateString) {
      return { success: false, data: null, message: "No date to look up" };
    }
    return await getCall({ path: `/facial-recognition-attendance/days/self/by-date/${encodeURIComponent(dateString)}`, });
  };

  export const markWebAttendance = async (input = {}) => {
    return await postCall({ path: `/facial-recognition-attendance/self/web-attendance`, bodyParams: input, });
  };
  

  